import {EMPTY, finalize, Observable} from 'rxjs';
import {signal} from '@angular/core';

export const updateInProgress = signal<boolean>(false);
export const hasGeneratedNewMetadata = signal<boolean>(false);
export const isRestoringPanZoom = signal<boolean>(false);
/** Set to true when user manually adds a property row, prevents form re-patching from stealing focus */
export const hasAddedNewProperty = signal<boolean>(false);
/** Set to true during undo/redo operations - forces form to sync with current state */
export const undoRedoJustHappened = signal<boolean>(false);
/** Set to true when multi-selection metadata change occurs - prevents duplicate singular property commands */
export const multiSelectionMetadataChanged = signal<boolean>(false);
/** Track element IDs involved in the last multi-selection metadata change */
export const lastMultiSelectionMetadataIds = signal<Set<string>>(new Set());
/**
 * True while the user is actively editing the metadata table (typing a
 * key/value, adding or removing a row). Lets the sidebar's multi-select
 * broadcast distinguish intentional bulk metadata edits from stale form
 * re-emits triggered by AI/external updates of the focused element.
 */
export const userEditedMetadata = signal<boolean>(false);

// Wrapper function to handle update state with an Observable-based operation
export function withUpdateInProgress<T>(operation: () => Observable<T>): Observable<T> {
  // If an update is already in progress, return an empty Observable to skip the request
  if (updateInProgress()) {
    return EMPTY;
  }

  // Set updateInProgress to true and execute the operation
  updateInProgress.set(true);

  return operation().pipe(
    finalize(() => {
      // Always reset updateInProgress to false after the Observable completes
      updateInProgress.set(false);
    })
  );
}
